/**
 * Instrument Master Tabs Index
 * 
 * Central export point for all tab components used in the InstrumentMaster admin page.
 * This modular structure allows each tab to be developed, tested, and maintained independently.
 * 
 * Usage:
 *   import { SearchBrowseTab, BrokerMappingsTab, ... } from './tabs';
 * 
 * @module InstrumentMaster/tabs
 */

export { default as SearchBrowseTab } from './SearchBrowseTab';
export { default as BrokerMappingsTab } from './BrokerMappingsTab';
export { default as ScheduledRunsTab } from './ScheduledRunsTab';
export { default as BrokerPriorityTab } from './BrokerPriorityTab';
export { default as ReconciliationTab } from './ReconciliationTab';
